import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { Link } from '@design-system/link';
export const LinkWrapper = (_a) => {
    var { ariaHidden, ariaLabel, children, font, onClick, path, tabIndex, withLink = true } = _a, props = __rest(_a, ["ariaHidden", "ariaLabel", "children", "font", "onClick", "path", "tabIndex", "withLink"]);
    const commonProps = Object.assign({ width: '100%', font }, props);
    if (withLink && path) {
        return (_jsx(StyledLink, Object.assign({ "aria-hidden": ariaHidden, "aria-label": ariaLabel, onClick: onClick, styledOnlyOnHover: true, tabIndex: tabIndex, to: path }, commonProps, { children: children })));
    }
    if (withLink && onClick) {
        return (_jsx(CursorPointerWrapper, Object.assign({ onClick: onClick }, commonProps, { children: children })));
    }
    return _jsx(Box, Object.assign({}, commonProps, { children: children }));
};
export const StyledLink = styled(Link) ``;
export const CursorPointerWrapper = styled(Box) `
  cursor: pointer;
`;
//# sourceMappingURL=LinkWrapper.js.map